import { useEffect } from "react";

import { KHeaderWidget } from "../../../../models/configuration/components/kHeaderWidget";
import { Type } from "../../../../models/configuration/definitions/widget";
import { WidgetUIState } from "../../atoms";
import { useWidgetState } from "../../hooks";
import { UseKHeaderWidgetBurger, useKHeaderWidgetBurger } from "./useKHeaderWidgetBurger";
import {
  UseKHeaderWidgetComponents,
  useKHeaderWidgetComponents,
} from "./useKHeaderWidgetComponents";
import { UseKHeaderWidgetSelect, useKHeaderWidgetSelect } from "./useKHeaderWidgetSelect";

type UseKHeaderWidget = {
  burger: UseKHeaderWidgetBurger;
  configuration: UseKHeaderWidgetSelect;
  components: UseKHeaderWidgetComponents;
};

type UseKHeaderWidgetProps = {
  widgetId: KHeaderWidget["id"];
  barWidth: number | undefined;
};

export const useKHeaderWidget = ({
  widgetId,
  barWidth,
}: UseKHeaderWidgetProps): UseKHeaderWidget => {
  // Manage state
  const { setWidgetState } = useWidgetState({
    id: widgetId,
    type: Type.Header,
  });
  useEffect(() => {
    setWidgetState({ state: WidgetUIState.RENDERED });
  }, [setWidgetState]);

  // Configuraiton
  const configuration = useKHeaderWidgetSelect({ widgetId });

  // Burger
  const burger = useKHeaderWidgetBurger({ widgetId });

  // Components
  const components = useKHeaderWidgetComponents({ widgetId, barWidth });

  return {
    burger,
    configuration,
    components,
  };
};
